// 多语言配置
/*
  语言	文件名称
  简体中文 Upload	SimpleChinese
  英语 Upload	English
*/

import Vue from 'vue'
import VueI18n from 'vue-i18n'
import locale from 'element-ui/lib/locale'

//引入Element的语言包
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import enLocale from 'element-ui/lib/locale/lang/en'
import jaLocale from 'element-ui/lib/locale/lang/ja'


Vue.use(VueI18n)

const SUPPORTED_LOCALES = ['zh', 'en', 'ja'];
// 允许通过环境变量覆盖默认语言（如打包为中文）
const ENV_DEFAULT_LOCALE = (process.env && process.env.VUE_APP_DEFAULT_LOCALE) ? String(process.env.VUE_APP_DEFAULT_LOCALE).toLowerCase() : '';

function detectInitialLocale() {
  // 优先使用环境变量设置的默认语言
  if (SUPPORTED_LOCALES.includes(ENV_DEFAULT_LOCALE)) {
    return ENV_DEFAULT_LOCALE;
  }
  // 其次根据浏览器语言自动检测
  const nav = (navigator.language || navigator.userLanguage || 'en').toLowerCase();
  const base = nav.split('-')[0];
  return SUPPORTED_LOCALES.includes(base) ? base : 'en';
}

// 仅根据浏览器语言进行检测（不受环境变量影响），用于运行时语言切换
export function detectBrowserLocale() {
  const nav = (navigator.language || navigator.userLanguage || 'en').toLowerCase();
  const base = nav.split('-')[0];
  return SUPPORTED_LOCALES.includes(base) ? base : 'en';
}

const i18n = new VueI18n({
  locale: detectInitialLocale(), // 初始化时根据本地或浏览器语言
  messages: {
    'zh': Object.assign(require('./i18n/SimpleChinese'), zhLocale), // 中文
    'en': Object.assign(require('./i18n/English'), enLocale), // 英文
    'ja': Object.assign(require('./i18n/Japanese'), jaLocale), // 日语
  }
})

locale.i18n((key, value) => i18n.t(key, value)) //兼容element
window.i18n = i18n

export default i18n
